import { React } from 'react';
// Mui components
import { Typography, Box } from '@mui/material';

export default function ChipEstadoSolicitud({ backGroundColor, text, colorText }) {
  return (
    <Box
      sx={{
        borderRadius: '8px',
        width: 'auto',
        padding: '6px 8px',
        height: '2rem',
        backgroundColor: backGroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
      <Typography variant="lists" sx={{ color: colorText || 'black' }}>
        {text}
      </Typography>
    </Box>
  );
}
